import React, { FC } from 'react';
import Modal from '@components/Modal';
import CreateEditGovernmentForm from '@/lib/CreateEditGovernmentForm';

type Props = {
  onClose: () => void;
  onSubmit: () => Promise<void>;
  data?: {
    name: string;
    description: string | null;
    id: string;
  };
};

const CreateEditGovernmentFormModal: FC<Props> = ({ onSubmit, onClose, data }) => (
  <Modal title={`${data ? 'Edit' : 'Create'} Government Form`} onClose={onClose} >
    <CreateEditGovernmentForm onSubmit={onSubmit} data={data}/>
  </Modal>
);

export default CreateEditGovernmentFormModal;
